<template>
  <div class="bottom">
    <div class="left-center">
      <div class="title">种植情况</div>
      <div class="digital-frame bottom">
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{plantingSituation.plantOutput}}</span>
            <span class="unit font-size12">万元</span>
          </div>
          <div class="font-fam-CN font-size14">种植年产值</div>
        </div>
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{plantingSituation.plantUnit}}</span>
            <span class="unit font-size12">个</span>
          </div>
          <div class="font-fam-CN font-size14">种植主体</div>
        </div>
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{plantingSituation.plantArea}}</span>
            <span class="unit font-size12">亩</span>
          </div>
          <div class="font-fam-CN font-size14">种植面积</div>
        </div>
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{plantingSituation.plantVariety}}</span>
            <span class="unit font-size12">种</span>
          </div>
          <div class="font-fam-CN font-size14">种植品种</div>
        </div>
      </div>
      <div id="planting" ref="plantingEchart"></div>
    </div>
    <div class="left-bottom">
      <div class="title">加工产业</div>
      <div class="digital-frame processing-industry">
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{ProcessingIndustry.processOutput}}</span>
            <span class="unit font-size12">万元</span>
          </div>
          <div class="font-fam-CN font-size14">加工年产值</div>
        </div>
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{ProcessingIndustry.processUnit}}</span>
            <span class="unit font-size12">个</span>
          </div>
          <div class="font-fam-CN font-size14">加工主体</div>
        </div>
        <div class="digital">
          <div>
            <span class="num font-size18 frame-text">{{ProcessingIndustry.productNum}}</span>
            <span class="unit font-size12">个</span>
          </div>
          <div class="font-fam-CN font-size14">产品数量</div>
        </div>
      </div>
      <div class="processed-product">
        <div class="title-left">2020年可加工产值</div>
        <div id="product-echart" ref="productEchart"></div>
        <div class="info-case">
          <div class="right-info">优秀产品</div>
          <div
            class="info-text font-fam-SM font-size14"
            v-for="item in driedFruitsData"
            :key="item.id"
          >{{item.productName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var echarts = require("echarts");
import HighCharts from "highcharts";
export default {
  data() {
    return {
      plantingSituation: [],
      varietyData: {
        data: []
      },
      ProcessingIndustry: {},
      processingStatus: [],
      driedFruitsData: []
    };
  },
  created() {
    this.driedFruitsChangesr();
    this.scrollBar();
  },
  async mounted() {
    await this.$axios
      .get("/bigdata/index/getPlantSituationData")
      .then(res => {
        this.plantingSituation = res.data;
        this.varietyData.data = res.data.acreageRatioVos;

        for (let i = 0; i < this.varietyData.data.length; i++) {
          let { plantClassificationName: name } = this.varietyData.data[i];
          let { acreageRatio: y } = this.varietyData.data[i];
          delete this.varietyData.data[i].plantClassificationName;
          delete this.varietyData.data[i].acreageRatio;
          this.varietyData.data[i].name = name;
          this.varietyData.data[i].y = y;
        }
      })
      .catch(res => {
        console.log(res);
      });
    await this.$axios
      .get("/bigdata/index/getProcessSituationData")
      .then(res => {
        this.ProcessingIndustry = res.data;
        this.processingStatus = res.data.processOutputData;
        this.driedFruitsData = res.data.goodProducts;
      })
      .catch(res => {
        console.log(res);
      });
    this.plantingEchart();
    this.ProductEchart();
  },
  methods: {
    plantingEchart() {
      let data = this.varietyData.data;

      HighCharts.chart("planting", {
        credits: {
          enabled: false //不显示LOGO
        },
        chart: {
          type: "pie", //饼图
          backgroundColor: "none",
          options3d: {
            enabled: true, //使用3d功能
            alpha: 45, //延y轴向内的倾斜角度
            beta: 0
          },
          marginLeft: 170,
          marginTop: 20
        },
        legend: {
          enabled: true,
          symbolRadius: 0,
          maxHeight: 120,
          itemStyle: {
            color: "#FFFFFF",
            fontSize: 12
          },
          itemMarginTop: 8,
          layout: "vertical",
          align: "left", //水平方向位置
          verticalAlign: "top", //垂直方向位置
          x: 40, //距离x轴的距离
          y: 20 //距离Y轴的距离
        },
        title: {
          text: null
        },
        tooltip: {
          headerFormat: "{series.name}<br>",
          pointFormat: "{point.name}: <b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
          pie: {
            colors: ["#E7437F", "#26D9FF", "#FFFF00", "#00FF00"],
            size: "130%",
            allowPointSelect: true, //每个扇块能否选中
            cursor: "pointer", //鼠标指针
            depth: 15, //饼图的厚度
            showInLegend: true,
            dataLabels: {
              distance: 35, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: true, //是否显示饼图的线形tip
              padding: 0,
              format:
                "<b>{point.plantAcreage}</b>亩,<br> {point.percentage:.1f} %"
            }
          }
        },
        series: [
          {
            type: "pie",
            radius: "70%",
            name: "面积所占比", //统一的前置词,非必须
            data: data,
            label: {
              normal: {
                show: true,
                formatter: "{point.name}: <b>{point.percentage:.1f}%</b>"
              }
            }
          }
        ]
      });
    },
    ProductEchart() {
      let myCharts = this.$echarts.init(this.$refs.productEchart);
      let data = this.processingStatus;
      console.log(data)
      let dataName = [];
      for (var index in data) {
        dataName.push(data[index].name);
      }
      myCharts.setOption({
        tooltip: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: dataName,
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.7)",
                width: 1
              }
            }
          }
        ],
        yAxis: [
          {
            name: "(万元)",
            min: 0,
            max: 400,
            splitNumber: 5,
            axisLine: {
              show: false
            },
            nameTextStyle: {
              color: "rgba(255,255,255,0.5)",
              fontSize: 12,
              padding: [0, 0, 0, -40]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#092439"
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,0.5)",
                fontWeight: "Regular",
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: 20,
            data: data,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#61FDE5" },
                  { offset: 0.5, color: "#61FDE5" },
                  { offset: 1, color: "#00EAFF" }
                ])
              }
            }
          }
        ]
      });
    },
    driedFruitsChangesr() {
      if (this.driedFruitsData.length > 4) {
        this.driedFruitsData.push(this.driedFruitsData[0]);
        this.driedFruitsData.shift();
      }
    },
    scrollBar() {
      setInterval(this.driedFruitsChangesr, 2000);
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom {
  width: 514px;
  .left-center {
    width: 100%;
    height: 263px;
    margin: 8px 0;
    background: url("../../../assets/bgIcon/plant.png") no-repeat;
    background-size: 100% 100%;
    #planting {
      width: 100%;
      height: 145px;
    }
  }
  .digital-frame {
    display: flex;
    padding-top: 12px;
    .digital {
      width: 110px;
      height: 60px;
      background: rgba(17, 35, 59, 1);
      border: 1px solid rgba(102, 204, 255, 0.4);
      box-shadow: 0px 0px 16px 4px rgba(0, 50, 49, 0.52);
      text-align: center;
      margin-right: 20px;
      padding-top: 6px;
    }
  }
  .bottom .digital:first-child {
    margin-left: 23px;
  }
  .left-bottom {
    width: 100%;
    height: 267px;
    background: url("../../../assets/bgIcon/process.png") no-repeat;
    background-size: 100% 100%;
    .digital-frame .digital:first-child {
      margin-left: 52px;
    }
    .processing-industry {
      .digital {
        margin-right: 40px;
      }
    }
    .processed-product {
      display: flex;
      //  position: relative;
      .title-left {
        margin: 0 34px 0 -65px;
        transform: rotate(90deg);
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: rgba(246, 246, 246, 1);
        line-height: 24px;
        background-image: -webkit-linear-gradient(left, #f6f6f6ff, #47abff99);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      #product-echart {
        width: 230px;
        height: 150px;
      }
      .info-case {
        width: 116px;
        height: 136px;
        background: url("../../../assets/bgIcon/juxing587.png") no-repeat;
        background-size: 100% 100%;
        margin: 5px 0 0 24px;
        text-align: center;
        overflow: hidden;
        .right-info {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 24px;
          padding-top: 10px;
          background-image: -webkit-linear-gradient(top, #24f1fe, #47abff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .info-text {
          line-height: 24px;
          color: rgba(246, 246, 246, 0.7);
        }
      }
    }
  }
}
</style>
